import { render, staticRenderFns } from "./AppointmentService.vue?vue&type=template&id=6286d7ec&scoped=true"
import script from "./AppointmentService.vue?vue&type=script&lang=js"
export * from "./AppointmentService.vue?vue&type=script&lang=js"
import style0 from "./AppointmentService.vue?vue&type=style&index=0&id=6286d7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6286d7ec",
  null
  
)

export default component.exports